module.exports = __webpack_public_path__ + "static/img/third2_1_4_active.e7109004.jpg";